import { ToastServiceMethods } from 'primevue/toastservice'
import type { ToastMessageOptions } from 'primevue/toast'
import type { ApiError } from './ApiError'

const infoToast = function (
  toast: ToastServiceMethods,
  title: string,
  message: string,
  dataTestId?: string,
): void {
  toast.add({
    severity: 'info',
    summary: title,
    detail: message,
    life: 5000,
    ...(dataTestId && { data: { 'data-test-id': dataTestId } }),
  })
}

const warnToast = function (
  toast: ToastServiceMethods,
  title: string,
  message: string,
  dataTestId?: string,
): void {
  toast.add({
    severity: 'warn',
    summary: title,
    detail: message,
    life: 5000,
    ...(dataTestId && { data: { 'data-test-id': dataTestId } }),
  })
}

const successToast = function (
  toast: ToastServiceMethods,
  title: string,
  message: string,
  dataTestId?: string,
): void {
  toast.add({
    severity: 'success',
    summary: title,
    detail: message,
    life: 5000,
    ...(dataTestId && { data: { 'data-test-id': dataTestId } }),
  })
}

const errorToast = function (
  toast: ToastServiceMethods,
  title: string,
  message: string,
  dataTestId?: string,
): void {
  toast.add({
    severity: 'error',
    summary: title,
    detail: message,
    ...(dataTestId && { data: { 'data-test-id': dataTestId } }),
  })
}

/**
 * Shows an error toast with a "More Details" link that opens the error details drawer.
 * Use this when you have an ApiError with correlation ID and want to provide
 * detailed debugging information to the user.
 *
 * @param toast - PrimeVue toast service
 * @param title - Toast title/summary
 * @param message - Toast message/detail
 * @param error - The ApiError object with detailed information
 * @param dataTestId - Optional test ID for the toast
 */
const errorToastWithDetails = function (
  toast: ToastServiceMethods,
  title: string,
  message: string,
  error: ApiError,
  dataTestId?: string,
): void {
  // PrimeVue ToastMessageOptions doesn't declare 'data'; we pass it for App.vue toast template (More Details link)
  toast.add({
    severity: 'error',
    summary: title,
    detail: message,
    data: {
      ...(dataTestId && { 'data-test-id': dataTestId }),
      apiError: error,
      hasDetails: true,
    },
  } as ToastMessageOptions)
}

export { infoToast, warnToast, successToast, errorToast, errorToastWithDetails }
